import { render, staticRenderFns } from "./farmerloans.vue?vue&type=template&id=598bfb65&scoped=true"
import script from "./farmerloans.vue?vue&type=script&lang=js"
export * from "./farmerloans.vue?vue&type=script&lang=js"
import style0 from "./farmerloans.vue?vue&type=style&index=0&id=598bfb65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598bfb65",
  null
  
)

export default component.exports